import ButtonField from '@/components/form-control/ButtonField'
import { DATA_TABLE_ETZ } from '@/constant/common'
import { Stack, Typography } from '@mui/material'
import FooterSetup from '../../common/FooterSetup'
import MenuHeader from '../../common/MenuHeader'
import RightGoogleMapSmall from '../../common/RightGoogleMapSmall'
import SetUpLayout from '../../common/SetUpLayout'
import ETTable from './ETTable'

type Props = {}

const ETData = (props: Props) => {

  const handleClick = () => {

  }

  return (
    <SetUpLayout
      title='ET Zone'

      header={
        <MenuHeader />
      }
      rightLayout={<RightGoogleMapSmall />}
      footer={<Stack p="25px 32px"><FooterSetup /></Stack>}
    >
      <Stack direction="row" alignItems="center" justifyContent="space-between">
        <Typography sx={{ fontSize: "20px", lineHeight: "2.4" }}>Review ET Zone</Typography>
        <Stack alignItems="center">
          <ButtonField
            startIcon={<></>}
            style={{
              height: '32px',
              minWidth: '89px',
              borderRadius: '5px',
            }}
            name="Done"
            onClick={handleClick}
          />
        </Stack>
      </Stack>
      <ETTable rows={DATA_TABLE_ETZ} />
    </SetUpLayout>
  )
}

export default ETData